import {qspost, qspost2, postfile, getfile} from '@/plugins/axios'
import {SZST_URL} from "@/config";

/*
 * 获取机构logo
 * @constructor jack
 * */
export const getOrgLogo = (oid) => qspost('/Home/Index/getOrgLogo', {oid})
/*
 * 用户登录
 * @constructor jack
 * */
export const userLogin = (user_name,password,type) => qspost('Home/Index/login', {user_name,password,type})
export const agenLogin = (uid) => qspost('Home/Index/agenLogin', {uid})
export const agenSonLogin = (sonsign) => qspost('home/index/agenSonLogin', {sonsign})

/*
 * 用户登录
 * @constructor jack
 * */
export const phoneLogin = (phone,code,sign,type) => qspost('Home/Index/sms_login', {phone,code,sign,type})


/*
 * 微信登录
 * @constructor jack
 * */
export const wxLogin = (code,type,terminal) => qspost('Home/Index/wx_login', {code,type,terminal})

/*
 * 发送短信验证码
 * @constructor jack
 * 1
 * */
export const sendSms = (phone,type) => qspost('Home/Index/sms_send', {phone,type})


/*
 * 忘记密码发送短信验证码
 * @constructor jack
 * 1
 * */
export const sendForgetSms = (phoneNum,type) => qspost('home/index/forgetUserSMS', {phoneNum,type})



/*
 * 忘记密码
 * @constructor jack
 * */
export const changeUserPassByPhoneCode = (phoneNum,phoneCode,newPass,newrPass) =>
    qspost('home/index/changeUserPassByPhoneCode', {phoneNum,phoneCode,newPass,newrPass})



/*
 * 获取会员申请信息表单
 * @constructor jack
 * 1
 * */
export const emofLogin = (emofUserTokenSafer) => qspost('/Home/Index/emof_login', {emofUserTokenSafer})



/*
 * 第三方的 用户登录
 * @constructor jack
 * 1
 * */
export const thirdPartyLogin = (code) => qspost('/home/index/thirdPartyLogin', {code})



/*
 * 获取会员申请信息表单
 * @constructor jack
 * 1
 * */
export const getCompanyUserMoreJson = (oid) => qspost2('/home/Other/getCompanyUserMoreJson', {oid})


/*
 * 级别列表
 *  * @constructor jack
 * */
export const getApplyRankList = (oid,type = 1,user_type) => qspost('/home/Other/getRankList', {oid,type,user_type})

/*
 * 获取会员申请信息表单
 * @constructor jack
 * 1
 * */
export const getCompanyUserMoreJsonFh = (fenhui_id) => qspost2('/home/Other/getCompanyUserMoreJsonFh', {fenhui_id})


/*
 * 级别列表
 *  * @constructor jack
 * */
export const getApplyRankListFh = (fenhui_id,user_type) => qspost('/home/Other/getRankListFh', {fenhui_id,user_type})

/*
 * 检查机构的网站配置信息
 * @constructor jack
 * */
export const checkWebSetInfo = (oid,fenhui_id) => qspost2('/home/Other/checkWebSetInfo', {oid,fenhui_id})

/*
 * 会员管理-会员添加
 * userType  2个人  1机构
 * @constructor jack
 * */
export const memberApply = (userMoreJson,oid,userType,register_type,evidence,share_id) => qspost2('/home/Other/setUser', {userMoreJson,oid,userType,register_type,evidence,share_id})

/*
 * 会员管理-会员添加
 * userType  2个人  1机构
 * @constructor jack
 * */
export const userGetSelfBaseInfo = () => qspost('/home/Other/userGetSelfBaseInfo', {})
/*
 * 会员管理-会员添加
 * userType  2个人  1机构
 * @constructor jack
 * */
export const memberApplyFh = (userMoreJson,fenhui_id,userType,register_type,evidence,share_id) => qspost2('/Home/Other/yaoQingFHUser', {userMoreJson,fenhui_id,userType,register_type,evidence,share_id})

/*
 * 分会管理-分会添加
 * userType  2个人  1机构
 * @constructor jack
 * */
export const fhApply = (oid,logo,name,rankId,lianxiren,lianxidianhua,addresss,email
    ,website,desc) => qspost2('/home/Other/setUserFH', {oid,logo,name,rankId,lianxiren,lianxidianhua,addresss,email
    ,website,desc})

/*
 * 下载文件
 * @constructor jack
 * */
export const downloadFile = (url) => postfile('/home/Other/fileGetContents', {url})

/*
 * 迭代通知列表
 * */
export const getVersionList = (page,limit) => qspost2('home/Iterative/getList', {page,limit})

/*
 * 迭代通知列表
 * */
export const getVersionDetail = (id) => qspost2('home/Iterative/getInfo', {id})

/*
 * 检查微信支付
 * */
export const checkWechatPaymentInfo = (orgId,fenHuiId) => qspost2('home/Other/checkWechatPaymentInfo', {orgId,fenHuiId})
/*
 * 检查用户的注册支付状态
 * */
export const checkUserRegisterPayState = (orderNumber) => qspost2('home/Other/checkUserRegisterPayState', {orderNumber})

/*
 * 获得对公转账的信息
 * */

export const getDuiGongData = (orgId,fenHuiId) => qspost('home/Other/getDuiGongData', {orgId,fenHuiId})

/*
 * 获得分会的信息
 * */

export const getfenhuiList = (orgId,fenHuiId = '') => qspost('admin/user/getfenhuiList', {orgId,fenHuiId})

/*
 * 邀请获取会员类型描述
 * */

export const getUserTypeDesc = (oid,user_type) => qspost('home/other/getUserTypeDesc', {oid,user_type})


/**
 *  新版 登录
 *  @DATE 2023.3.29
 */
/*
 * 账号密码登陆
 * */
export const userNewLogin = (user_name,password) => qspost('home/Login/login', {user_name,password})

/*
 * 手机短信快捷登录
 * */
export const phoneNewLogin = (phone,code) => qspost('home/Login/sms_login', {phone,code})

/*
 * 微信登录
 * */
export const wxNewLogin = (code,terminal) => qspost('home/Login/wx_login', {code,terminal})

/*
 * 第三方的 用户登录
 * @constructor jack
 * 1
 * */
export const thirdPartyNewLogin = (code) => qspost('/home/Login/thirdPartyLogin', {code})

/*
 * 益魔方的 用户登录
 * */
export const emofNewLogin = (emofUserTokenSafer) => qspost('/home/Login/emof_login', {emofUserTokenSafer})

/*
 * 更新账号角色
 * */
export const updateUserLogin = (account) => qspost('/home/Login/updateUserLogin', {account})


/*
 * 修改密码
 * */
export const forgetPassword = (phoneNum,phoneCode,newPass,newrPass) => qspost('/home/Login/changeUserPassByPhoneCode', {phoneNum,phoneCode,newPass,newrPass})



/*
 * 迭代通知不再提醒
 * */
export const noRemind = (id,type,link_id) => qspost('/home/Iterative/noRemind', {id,type,link_id})

/*
 * 获取文件流
 * */
export const getFileBlob = (url) => getfile(url, {})

/*
 * 服务协议、隐私政策
 * */
export const getAgreement = () => qspost(SZST_URL + 'api/index/agreement', {})


/*
 * 用户协议
 * */
export const getMiniAgreement = () => qspost('/admin/common/miniAgreement', {})

